// src/components/Auth/PhoenixSignup.js
import React, { useState } from 'react';
import { authApi } from '../../api'; 
import { useNavigate, Link as RouterLink, Navigate } from 'react-router-dom';
import { getAuthToken, isSessionExpired } from '../../api/authSession';

const PhoenixSignup = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const token = getAuthToken();
    const isExpired = isSessionExpired();

    // If user is already authenticated with an active session, redirect directly to dashboard
    if (token && !isExpired) {
        return <Navigate to="/" replace />;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await authApi.signup(email);
            alert("Account verification request received. Please proceed to login.");
            navigate('/login');
        } catch (err) {
            console.error("Signup trap error:", err);
            navigate('/login');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page-wrapper">
            <div className="auth-card signup-card">
                <div className="auth-shield-icon-wrapper">
                    <i className="fas fa-id-badge"></i>
                </div>

                <h2>Request Access</h2>
                <div className="auth-tagline">Admin Permission Request</div>

                <p className="auth-subtext">
                    Enter your official institutional email ID to request administrative credentials.
                </p>

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="auth-input-group">
                        <label>Institutional Email</label>
                        <div className="auth-input-box">
                            <i className="fas fa-envelope"></i>
                            <input
                                type="email"
                                placeholder="name@diet.edu.in"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <button type="submit" className="admin-btn-primary auth-submit-btn" disabled={loading}>
                        {loading ? (
                            <>
                                <i className="fas fa-circle-notch fa-spin"></i> Submitting...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-paper-plane"></i> Submit Request
                            </>
                        )}
                    </button>
                </form>

                <p className="auth-footer-link">
                    Already registered? <RouterLink to="/login">Back to Login</RouterLink>
                </p>
            </div>
        </div>
    );
};

export default PhoenixSignup;